import { ReusableSection } from "@with-nx/simple-ui/atoms";
import { CatalogLayout } from "@with-nx/simple-ui/organisms";

import ReusableSearchSection from "../../components/w/ReusableSearchSection";
export const getServerSideProps = async ({ resolvedUrl }) => {
  return {
    props: {
      resolvedUrl,
    },
  };
};
const GlobalProductSearch = ({ resolvedUrl }) => {
  return (
    <CatalogLayout
      footerNoAngle
      title="Broadway Media - Search"
      resolvedUrl={resolvedUrl}
    >
      <div className="container mx-auto max-w-7xl">
        <ReusableSection background="transparent">
          <ReusableSearchSection productCategory="global" autoPopulateQuery />
        </ReusableSection>
      </div>
    </CatalogLayout>
  );
};

export default GlobalProductSearch;
